// Add to your user/website api file (same axiosInstance + secureStorage + toast).
import axiosInstance from "../../../axiosInstance";
import { secureStorage } from "../../../utils/secureStorage";
import toast from "react-hot-toast";

export const updateProfileApi = async (id, payload, onDone) => {
  const token = secureStorage.getItem("accessToken");
  try {
    const res = await axiosInstance.put(
      `/profile/user/profile/${id}`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    // keep the stored user in sync so the UI reflects the change everywhere
    const current = secureStorage.getItem("user") || {};
    secureStorage.setItem("user", { ...current, ...res.data.user });
    toast.success(res.data?.message || "Profile updated");
    onDone && onDone(res.data.user);
  } catch (err) {
    console.error(err);
    toast.error(err?.response?.data?.message || "Update failed");
  }
};

export const changePasswordApi = async (id, payload, onDone) => {
  const token = secureStorage.getItem("accessToken");
  try {
    const res = await axiosInstance.put(
      `/profile/user/change-password/${id}`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    toast.success(res.data?.message || "Password changed");
    onDone && onDone();
  } catch (err) {
    console.error(err);
    toast.error(err?.response?.data?.message || "Could not change password");
  }
};
